import _ from 'lodash'
import moment from 'moment'
import { CancelToken } from 'axios'

import {
  FETCHING_EVALUATION,
  FETCHED_EVALUATION,
  SAVE_EVALUATION,
  SAVE_PARTIAL_EVALUATION,
  UPDATE_EVALUATION_PLANNING,
} from '_reducers/evaluations'
import { MydAPI } from '_services/default'

import { deserializeNodeData } from '_actions/nodes'
import { getParentTreeNode } from '_actions/treeNodes'
import { fetchWidget, deserializeWidgetData, defaultIncludes } from '_actions/widgets'


function _fetchingEvaluation() {
  return {
    type: FETCHING_EVALUATION,
  }
}

function _fetchedEvaluation(evaluation) {
  return {
    type: FETCHED_EVALUATION,
    evaluation,
  }
}

function _saveEvaluation(evaluation) {
  return {
    type: SAVE_EVALUATION,
    evaluation,
  }
}

function _updateEvaluationPlanning(evaluation, action) {
  return {
    type: UPDATE_EVALUATION_PLANNING,
    evaluation,
    action,
  }
}

export function _savePartialEvaluation(evaluation) {
  return {
    type: SAVE_PARTIAL_EVALUATION,
    evaluation,
  }
}

const deserializeEvaluationData = (evaluation, included) => {
  let retEvaluation = {
    id: evaluation.id,
    ...evaluation.attributes,
    methodologies: _.map(_.get(evaluation.relationships, 'methodologies.data', []), rel => {
      return _.chain(included).find({
        id: _.parseInt(rel.id),
        type: 'ict_methodology',
      }).get('id').value()
    }),
    indicators: _.reduce(_.get(evaluation.relationships, 'indicators.data', []), (ret, rel) => {
      let indicators = _.filter(included, {
        id: _.parseInt(rel.id),
        type: 'ict_evaluation_indicator',
      })

      return [
        ...ret,
        ..._.map(indicators, d => ({
          id: d.id,
          ...d.attributes,
        }))
      ]
    }, []),
  }

  return retEvaluation
}

export function saveEvaluation(evaluation, planningId=false) {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_saveEvaluation(evaluation))
    let data = _serializeEvaluationData(evaluation)

    if (evaluation.id) {
      data = {
        ...data,
        id: _.toString(evaluation.id),
      }

      MydAPI.patch(`/ict/evaluations/${evaluation.id}?include=methodologies,indicators`, {data}).then(
        response => {
          let retEvaluation = deserializeEvaluationData(response.data.data, response.data.included)
          dispatch(_updateEvaluationPlanning(retEvaluation, 'update'))
          resolve(retEvaluation)
        }
      ).catch(err => {
        reject(err)
        alert(err)
      })

    } else {

      MydAPI.post(`/ict/plannings/${planningId}/evaluations?include=methodologies,indicators`, {data}).then(
        response => {
          let retEvaluation = deserializeEvaluationData(response.data.data, response.data.included)
          dispatch(_updateEvaluationPlanning(retEvaluation, 'add'))
          resolve(retEvaluation)
        }
      ).catch(err => {
        reject(err)
      })
    }
  })
}

function _serializeEvaluationData(evaluation) {
  let { casnodeId, instrumentId, evaluationAssigned, isLocked, date, planningId, methodologies } = evaluation

  return {
    type: 'ict_evaluation',
    attributes: {
      casnode_id: casnodeId,
      instrument_id: instrumentId,
      evaluation_assigned: evaluationAssigned,
      is_locked: isLocked,
      date: moment.isMoment(date) ? date.format('YYYY-MM-DD hh:mm:ss Z') : null,
      planning_id: planningId,
    },
    relationships: {
      methodologies: {
        data: _.map(methodologies, i => ({type:'methodology', id: _.toString(i)})),
      },
    }
  }
}


let fetchEvaluationsByPlanningIdCancelToken = null

export function fetchEvaluationsByPlanningId(planningId) {
  return dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingEvaluation())

    if (fetchEvaluationsByPlanningIdCancelToken) {
      fetchEvaluationsByPlanningIdCancelToken()
    }

    MydAPI.get(
      `/ict/plannings/${planningId}/evaluations?include=methodologies,indicators&page[size]=0`,
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchEvaluationsByPlanningIdCancelToken = c
        })
      }
    ).then(response => {
      let retEvaluation = _.map(response.data.data, evaluation => {
        let date = evaluation.attributes.date
        date = date !== null ? moment(date) : moment()

        let ret = deserializeEvaluationData(evaluation, response.data.included)

        return {
          ...ret,
          date,
        }
      })

      dispatch(_fetchedEvaluation(retEvaluation))
      resolve(retEvaluation)

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}

export function fetchEvaluation(evaluationId) {
  return dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingEvaluation())

    MydAPI.get(`/ict/evaluations/${evaluationId}?include=methodologies,indicators,associated_widgets&page[size]=0`).then(response => {
      let evaluation = response.data.data
          //date = evaluation.attributes.date !== null ? moment(evaluation.attributes.date) : moment()

      let retEvaluation = deserializeEvaluationData(evaluation, response.data.included)

      let associatedWidgetId = _.get(evaluation.relationships, 'associated_widgets.data[0].id', false)
      if (associatedWidgetId) {
        fetchWidget(associatedWidgetId)
        .then(
          associatedWidget => {
            retEvaluation = {
              ...retEvaluation,
              associatedWidget,
            }

            dispatch(_fetchedEvaluation(retEvaluation))
            resolve(retEvaluation)
          }
        ).catch(reject)
      } else {
        dispatch(_fetchedEvaluation(retEvaluation))
        resolve(retEvaluation)
      }

    }).catch(err => {
      reject(err)
    })
  })
}

export function fetchIndicators(planningId) {
  return dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingEvaluation())

    MydAPI.get(`/ict/plannings/${planningId}/evaluations?page[size]=0`).then(evaluation => {
      let retEvaluation = _.map(evaluation.data.data, evaluation => {
        let date = evaluation.attributes.date
        date = date !== null ? moment(date) : null

        return {
          id: evaluation.id,
          ...evaluation.attributes,
          date,
        }
      })

      dispatch(_fetchedEvaluation(retEvaluation))
      resolve(retEvaluation)

    }).catch(err => {
      reject(err)
    })
  })
}


export function saveEvaluationIndicator(indicator, evaluationId) {
  return new Promise((resolve, reject) => {

    let data = {
          attributes: {
            indicator_id: indicator.indicatorId,
            evaluation_id: evaluationId,
            rate: indicator.rate,
          },
          type: 'ict_evaluation_indicator'
        },
        apiCall = null

    if (indicator.id) {
      data.id = _.toString(indicator.id)
      apiCall = MydAPI.patch(`/ict/evaluations/${evaluationId}/indicators/${indicator.id}`, {data})
    } else {
      apiCall = MydAPI.post(`/ict/evaluations/${evaluationId}/indicators`, {data})
    }

    apiCall.then(
      d => {
        resolve({
          id: d.data.data.id,
          ...d.data.data.attributes,
        })
      }
    ).catch(err => {
      reject(err)
    })
  })
}


export function fetchEvaluationNodes() {
  return new Promise((resolve, reject) => {

    MydAPI.get('/ict/evaluations/cas/nodes?include=node_object,node_object.indicators,node_object.default_evaluations,node_object.default_evaluations.methodologies?page[size]=0').then(
      d => {
        let retNodes = deserializeNodeData(d.data)
        resolve(retNodes)
      }
    ).catch(err => {
      reject('Server Error.')
    })
  })
}


export function fetchEvaluationsByWidgetId(widgetId) {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/widgets/${widgetId}/evaluations?page[size]=0&include=indicators,node.node_object.indicators`).then(response => {
      let res = response.data,
          item = res.data

      if (item === null) {
        resolve(null)
        return
      }

      let desItem = _.filter(res.included, {type: 'ict_evaluation_indicator'}),
          retWidget = {
            evaluationConf: {
              id: item.id,
              ...item.attributes,
            },
            node: deserializeNodeData(
              {
                data: [_.find(res.included, {
                  id: _.parseInt(item.relationships.node.data.id),
                  type: 'cas_node',
                })],
                included: res.included,
              }
            ),
            indicatorsConf: _.map(desItem, r => ({
              id: r.id,
              ...r.attributes,
            }))
          }

      resolve(retWidget)

    }).catch(err => {
      reject(err)
    })
  })
}

export function fetchEvaluationsResultByIndicatorId(evaluationId, indicatorId) {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/ict/evaluations/${evaluationId}/indicators/${indicatorId}/results?page[size]=0`).then(response => {
      let res = response.data,
          item = res.data

      if (_.isEmpty(item)) {
        resolve({})
        return
      }

      resolve({
        id: item[0].id,
        ...item[0].attributes,
      })

    }).catch(err => {
      reject(err)
    })
  })
}

export function associateWidgetToEvaluation(widgetId, data) {
  return new Promise((resolve, reject) => {

    MydAPI.post(`widgets/${widgetId}/relationships/evaluations?include=widget,evaluation,widget.owner,evaluation.node.node_object`, data).then(response => {
        resolve(deserializeWidgetData(_.find(response.data.included, {type: 'widget'}), response.data.included))
    })
  })
}

export function fetchWidgetAssociatedToEvaluation(evaluationId) {
  return new Promise((resolve, reject) => {

    MydAPI.get(`ict/evaluations/${evaluationId}/associated_widgets?include=${defaultIncludes().join(',')}`).then(
      response => {
        if( !_.isEmpty(response.data.data[0])) {
          resolve(deserializeWidgetData(response.data.data[0], response.data.included))
        } else { resolve({}) }
    }).catch(err => {
      reject(err)
    })
  })
}

export function unassignWidgetToTask(widgetId, evaluationId) {
  return new Promise((resolve, reject) => {

    MydAPI.delete(`widgets/${widgetId}/relationships/evaluations/${evaluationId}`).then(response => {
      resolve(response)
    })
  })
}

export function fetchEvaluationsByNodeId(nodeId) {
  return new Promise((resolve, reject) => {

    MydAPI.get(`cas/nodes/${nodeId}/evaluations?include=planning.treenodes.parent.parent.parent.parent.parent.parent`).then(response => {
      let promises = _.map(
        response.data.data,
        item => fetchWidgetAssociatedToEvaluation(item.id)
      )

      Promise.all(promises).then(
        values => {
          resolve(
            _.map(
              response.data.data,
              (item, index) => {
                let planning = _.find(
                      response.data.included,
                      {
                        id: _.parseInt(item.relationships.planning.data.id, 10),
                        type: item.relationships.planning.data.type,
                      }
                    )

                return {
                  id: item.id,
                  ...item.attributes,
                  planning: {
                    id: planning.id,
                    ...planning.attributes,
                    treeNodes: _.reduce(
                      planning.relationships.treenodes.data,
                      (red, tn) => {
                        let tnDetail = _.find(
                          response.data.included,
                          {
                            id: _.parseInt(tn.id, 10),
                            type: tn.type,
                          }
                        )
                        return [
                          ...red,
                          ...getParentTreeNode(tnDetail, response.data.included),
                        ]
                      },
                      []
                    ),
                  },
                  widget: values[index],
                }
              }
            )
          )
        }
      ).catch(err => reject(err))
    }).catch(err => reject(err))
  })
}
